import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren,ChangeDetectionStrategy,Inject, ChangeDetectorRef } from '@angular/core';

import { ModalService } from 'src/app/Modals/_modal';
import { WebsocketService } from 'src/app/services/websockets/web-socket-service.service';
import * as uuid from 'uuid'
import {TuiDialogContext, TuiDialogService} from '@taiga-ui/core';
import {PolymorpheusContent} from '@tinkoff/ng-polymorpheus';
import {FormControl, FormGroup} from '@angular/forms';
import { ReplaySubject } from 'rxjs';


@Component({
  selector: 'app-chat-container',
  templateUrl: './chat-container.component.html',
  styleUrls: ['./chat-container.component.sass']
})
export class ChatContainerComponent implements OnInit {

  constructor(
    private http:HttpClient,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    public service:WebsocketService,
    private readonly changeDetector: ChangeDetectorRef
    ) {}

  @ViewChildren('messages') messages: QueryList<any>;
  @ViewChild('content') content: ElementRef;

  isLoading=false
  usersArray:any
  currentUser:any
  username = localStorage.getItem("userId")
  text:string = ""
  chats:any[] =[]
  searchtext:string=""
  array:any[] =[]
  selectedUser:string=""
  chatRooms:any[] = []
  isHidden:boolean = false
  title:string =""
  members:string =""
  currentIdSpinner = "spinner"+uuid.v4();
  currentRoom:any
  public isEmojiPickerVisible: boolean;
  isHiddenOptions = false
  reply=null
  searchText:string=""

  imagebase64:any ="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"

  profile:any =""

  isDisabed = true
  roomId:any
  dev_api ="http://localhost:443"
  prod_api ="https://server.flowspaceproducitivity.com"
  AudioCalling:boolean = false
  VideoCalling:boolean = true
  fileUploadApi = "Yauj2ne4aVEjPjcjXf3vFhw93APcr7hm"

  usernames = new FormGroup({
    names: new FormControl(''),
  });

  ngOnInit(): void {
    this.http.get(this.prod_api+"/users/migrate").subscribe(data=>{
      this.usersArray = data
    })

    this.http.get(this.prod_api+"/users/get_users?OwnerToken="+this.username).subscribe(data=>{
      this.currentUser = data
      this.http.get(this.prod_api+"/users/photos?id="+this.currentUser.profile_pic).subscribe(data=>{
      },err=>{
        //console.log(err)
        this.imagebase64 = err.error.text
      })
      this.service.updateUserChatContainerNoInit(this.currentUser)  
  
      
    })


    
    //console.log(this.service.chatRooms)
   
  

    this.service.chatRooms.subscribe(data=>{
      if(data != undefined || data != null){
        this.chatRooms = data.sort((p1, p2) => (p1.order > p2.order) ? 1 : (p1.order < p2.order) ? -1 : 0)
        //console.log(data)
        //console.log("new Chat Started")
        
      }
    
    })

  }

  ngAfterViewInit() {
    this.isLoading =true
    this.scrollToBottom();
    this.messages.changes.subscribe(this.scrollToBottom);
  }
  
  scrollToBottom(){
    try {
      let el = document.getElementById("messages")
      el.scrollTo(0,el.scrollHeight)
      this.content.nativeElement.scrollToBottom
    } finally{
      //console.log("tried")
      this.isLoading = false
    }
  }


  updateMessages(){
    var value = this.text.replace(/\n\r?/g, '<br/>')
    var real = value.replace(/<br\s*\/?>/gi,'')
    console.warn(this.text)
    console.warn(value)
    console.warn(real)
    console.warn(real.length)
    if(real.length>0){
      if(this.reply==null){
        const m = {
          roomId:this.roomId,
          to:null,
          attachments:'',
          content: value,
          time: new Date().toTimeString().split(/\s+/)[0],
          from: this.username,
          date: new Date().toDateString(),
          type: "text",
          id: uuid.v4()
        }
       
        var recipient 
        if(this.username == this.currentRoom.from){
          recipient = this.currentRoom.to
        }else{
          recipient = this.currentRoom.from
        }
    
        this.service.sendMessage(m,this.currentRoom)
        this.currentRoom.lastMessage = this.text
        this.text ="" 
      }else{
        const m = {
          roomId:this.roomId,
          to:null,
          attachments:'',
          content: value,
          time: new Date().toTimeString().split(/\s+/)[0],
          from: this.username,
          date: new Date().toDateString(),
          type: "text",
          replyMess: this.reply.content,
          replyID: this.reply.id,
          id: uuid.v4()
        }

        var recipient 
        if(this.username == this.currentRoom.from){
          recipient = this.currentRoom.to
        }else{
          recipient = this.currentRoom.from
        }
    
        this.service.sendMessage(m,this.currentRoom)
        this.currentRoom.lastMessage = this.text
        this.text ="" 
        this.reply=null
      }
     
    }
    
    
  }

  sendNewChat(chatroom:any,message:any){
    //console.log(this.selectedUser)
    this.service.newChat(chatroom,message,this.selectedUser,this.username);
  }

  updateChats(messages:any){
    this.isLoading = true
    this.chats = messages.messages
    //console.log(this.chats)
    this.roomId = messages.roomId
    this.currentRoom = messages.room

    this.isHidden = true;
    this.isDisabed = false
    this.title = messages.title
    this.members = messages.members
    this.profile = messages.profile
    this.service.updateRoomId(this.roomId)
    this.isLoading = false

  }

  selectUser(username){
    this.isLoading = true
    //console.log("this code is running")
    this.selectedUser = username
    //console.log(this.selectedUser)
    const message = {
      from:this.username,
      roomId:uuid.v4(),
      attachments:'',
      content:"Hey, are you available?",
      date:new Date().toDateString(),
      time:new Date().toTimeString(),
      id:uuid.v4(),
      to:this.selectedUser,
      type:"text",
    }

    const chatRoom = {
      roomId:message.roomId,
      from:this.username,
      to:this.selectedUser,
      time:new Date().toTimeString(),
      lastMessage:"Hey, are you available?",
      participants:[this.username,this.selectedUser]
  
  }
    this.sendNewChat(chatRoom,message)
    this.isLoading = false
  }


public addEmoji(event) {
  this.text = `${this.text}${event.emoji.native}`;
}


showDialog(content: PolymorpheusContent<TuiDialogContext>): void {
  this.dialogService.open(content).subscribe();
}

isName(username){
  if(username.from != this.username){
    return username.from
  }
  return username.to
}
isLoadingFile = false

uploadImage(event:any){
  this.isLoading = true
  this.isLoadingFile = true
  var files = event.target.files
  const reader = new FileReader();
  reader.readAsDataURL(files.item(0));
  reader.onload = () => {
      const formData = new FormData();
      formData.append("image", files.item(0));
      formData.append("token", "Yauj2ne4aVEjPjcjXf3vFhw93APcr7hm");
 
      this.http.get("https://api.gofile.io/getServer").subscribe((data:any)=>{
        //console.log(data.data.server)
        var url = "https://"+data.data.server+".gofile.io/uploadFile"
        //console.log(url)
        this.http.post(url,formData,{
          reportProgress: true,
        }).subscribe((data:any)=>{

          

          //console.log(data.data)


          this.http.get("https://api.gofile.io/getContent?contentId="+data.data.parentFolder+"&token=Yauj2ne4aVEjPjcjXf3vFhw93APcr7hm").subscribe((dataFileLink:any)=>{
            var parent = data.data.fileId;
            console.log(dataFileLink.data.contents[parent]);
            
            const options = {
            'contentId': dataFileLink.data.contents[parent].id,
            'token': 'Yauj2ne4aVEjPjcjXf3vFhw93APcr7hm',
            'option': 'directLink',
            'value': 'true',
            };

            this.http.put("https://api.gofile.io/setOption", options).subscribe((data: any) => {
              console.log(data);
              if (data.status === 'ok') {
                if(this.text.length<=0){
                  const m = {
                    roomId:this.roomId,
                    to:null,
                    attachments:data.data,
                    content: "📷📷 Photo/File",
                    time: new Date().toTimeString().split(/\s+/)[0],
                    from: this.username,
                    date: new Date().toDateString(),
                    object: dataFileLink.data.contents[parent].mimetype,
                    type: "text",
                    id: uuid.v4()
                  }
    
                  console.log(m)
    
                  var recipient 
                  if(this.username == this.currentRoom.from){
                    recipient = this.currentRoom.to
                  }else{
                    recipient = this.currentRoom.from
                  }
              
                  this.service.sendMessage(m,this.currentRoom)
                  this.currentRoom.lastMessage = this.text
                  this.text ="" 
    
                  this.changeDetector.detectChanges()
                  this.isLoadingFile = false
                }else{
                  const m = {
                    roomId:this.roomId,
                    to:null,
                    attachments:data.data,
                    content: this.text,
                    time: new Date().toTimeString().split(/\s+/)[0],
                    from: this.username,
                    date: new Date().toDateString(),
                    object: dataFileLink.data.contents[parent].mimetype,
                    type: "text",
                    id: uuid.v4()
                  }
    
                  console.log(m)
    
                  var recipient 
                  if(this.username == this.currentRoom.from){
                    recipient = this.currentRoom.to
                  }else{
                    recipient = this.currentRoom.from
                  }
              
                  this.service.sendMessage(m,this.currentRoom)
                  this.currentRoom.lastMessage = this.text
                  this.text ="" 
    
                  this.changeDetector.detectChanges()
                  this.isLoadingFile = false
                  this.isLoading = false
                }
              }
              })
              

          })
  
  
          
  
          
         
        },err=>{
          //console.log(err)
          this.changeDetector.detectChanges()
        })
      })


     
  };

}

setupReply(eventData:any){
  this.reply=eventData
  this.reply.content = this.reply.content.replace(/<br\s*\/?>/gi,' ')
  //console.log(this.reply)
}



}
